import * as React from 'react';

import { mainSettingPanelComponent, MainSettingPanelComponentConfigurationContext } from './mainSettingPanelComponentConfiguration';

const withMainSettingPanelComponentConfiguration = <P extends object>(
    WrappedComponent: React.ComponentType<P>): React.FC<P> => {
    const HOC = (props: any): React.ReactElement => (
        <MainSettingPanelComponentConfigurationContext.Consumer>
            {(auth: any): React.ReactElement => {
                return (
                    <WrappedComponent {...props}{...mainSettingPanelComponent} />
                );
            }}
        </MainSettingPanelComponentConfigurationContext.Consumer>
    );

    HOC.displayName = `withAuthentication(${WrappedComponent.displayName || WrappedComponent.name})`;
    HOC.WrappedComponent = WrappedComponent;
    return HOC;
};

export default withMainSettingPanelComponentConfiguration;